module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA6BAMAAAAeiydcAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURf9MTEdwTP9LS/9LS/9OTv9KSv9KSv9LS/9LS/9MTHF9BfkAAAAJdFJOU8wAsWYNGkF873BrngAAAADuSURBVDjL3ZSxDoIwEIYvJcY4EqDIxsIOk7NvICzOTK4aExNHRzeJi/e29tqhUK+Ni4mhyyV8+eDuPwDi4IEv8aG3F+XFxTk+Lb5i4+A1viy+483BBaLFiMM/4B0GzgJWIfwADJ4548H3JhUzwfLcUkk3PYuPUFHpYMnhDEAoPSsBWgZLANI7VXoGp0A6yawd16STHLGtJaST3PBzkz6SXZwY3PhSqyfyB84Jn7yY2jbRcVjPrKNjcWdaq3hs5JE+xTqweqRPsQ5MR7f1bCwys7f8vimwxLNQdfPIRCfYZ++FTluW1cw+Ig/+3Z/pDVyhsue/IETHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notification/booking_rejected.png
// module id = 1813
// module chunks = 0